@let noImage = !filegroupStore.ActuarProfilePhotoById()[this.groupId]?.File?.Url && (!isPhotoInMemory || (isPhotoInMemory && !filegroupStore.PhotoInMemory()?.File?.Url)) && !src();
@let tooltipDisabled = noImage || tooltipFollowDisabled();


<!--
  Conteúdo do tooltip (cópia de 200px do avatar): só renderiza quando o tooltip
  pode abrir. Renderizar sempre duplicava a árvore de views de cada avatar da
  aplicação, inclusive nas telas que passam `tooltipFollowDisabled` e onde a
  cópia nunca é exibida. O `div` continua sempre no template porque
  `#avatarTemplateRef` é lido pela diretiva no `div` irmão, e uma variável de
  referência declarada dentro de um `@if` não é visível fora do bloco.
-->
<div #avatarTemplateRef class="hidden">
    @if (!tooltipDisabled) {
    <ng-container [ngTemplateOutlet]="avatarTemplate" [ngTemplateOutletContext]="{ customSize: 200 }"></ng-container>
    }
</div>


<div [tooltipFollowZIndex]="tooltipFollowZIndex()" [libTooltipFollow]="avatarTemplateRef" [tooltipFollowDisabled]="tooltipDisabled">
    <ng-container [ngTemplateOutlet]="avatarTemplate"></ng-container>
</div>

<ng-template #avatarTemplate let-customSizeCtx="customSize">
    @let resolvedCustomSize = customSizeCtx ?? customSize();
    @let sizePx = resolvedCustomSize ?? avatarSizes[size()];
    @let isProfile = resolvedType() === 'default';
    <section

    id="5948749B-8E44"
    class="pointer-events-none flex flex-col justify-end group overflow-hidden relative aspect-square bg-transparent {{
        avatarStatus[status()]
    }}"
    [ngStyle]="{ 'width.px': sizePx, 'height.px': sizePx }"
    [ngClass]="{
        'items-center' : !isProfile,
        'items-end rounded-full border border-border-solid' : isProfile,
    }"
    >
    <div
        class="w-full h-full flex justify-center items-center"
        [ngClass]="{
        'border-[2px] border-transparent': status(),
        'items-center': !isProfile,
        'items-end': isProfile
        }"
    >
        @if (noImage || !loaded()) { @switch (resolvedType()) { @case ('user') {
        <!--
          O tamanho tipográfico da sigla vive no wrapper (token do design kit por
          `size`, ou o calc proporcional quando há `customSize`). Cada `span`
          usa `.avatar-initials`, que lê esse valor como `1em` e só o reduz
          quando a sigla não caberia no círculo — ver o .scss.
        -->
        <div
        [ngClass]="{
            'rounded-full': style() === 'Circle',
            'rounded-[8px]': style() === 'Square',
            'text-[calc(var(--avatar-size)*0.52)]': resolvedCustomSize,
            'text-5xl': size() === 'lg' && !resolvedCustomSize,
            'header-lg': size() === 'sm' && !resolvedCustomSize,
        }"
        [style.--avatar-size]="sizePx + 'px'"
        [style.--avatar-initials-ratio]="initialsFontRatio()"
        class="flex items-center {{
            backgroundColor()
        }} justify-center w-full h-full text-header-foreground outline outline-1 outline-border-inverted -outline-offset-1"
        >
        @if (firstInitial()) {
        <span class="avatar-initials font-bold">{{ firstInitial() }}</span>
        } @if (lastInitial()) {
        <span class="avatar-initials font-bold">{{ lastInitial() }}</span>
        }
        </div>
        } @case ('default') {
        <svg
        [attr.width]="resolvedCustomSize ? '65.02%' : profileSizes[size()].width"
        [attr.height]="resolvedCustomSize ? '82.27%' : profileSizes[size()].height"
        viewBox="0 0 132 167"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M65.3787 67C83.8802 67 98.8787 52.0015 98.8787 33.5C98.8787 14.9985 83.8802 0 65.3787 0C46.8771 0 31.8787 14.9985 31.8787 33.5C31.8787 52.0015 46.8771 67 65.3787 67ZM65.7501 85.2006C31.3472 85.2006 3.08939 110.662 -0.000244141 143.175C17.6523 158.373 40.6277 167.561 65.7491 167.561C90.8713 167.561 113.847 158.373 131.5 143.173C128.41 110.661 100.152 85.2006 65.7501 85.2006Z"
            fill="#8A8E95"
        />
        </svg>
        } } } @if (isPhotoInMemory && filegroupStore.PhotoInMemory()?.File?.Url; as
        src) {
        <img
        (load)="onImageLoaded()"
        (error)="onImageError()"
        [src]="src"
        [ngClass]="{
            hidden: !loaded(),
            'rounded-full': style() === 'Circle',
            'rounded-[8px]': style() === 'Square'
        }"
        class="w-full aspect-square bg-background object-cover outline outline-1 outline-border-inverted -outline-offset-1"
        alt=""
        />
        } @if (filegroupStore.ActuarProfilePhotoById()[this.groupId]?.File?.Url; as
        src) {
        <img
        (load)="onImageLoaded()"
        (error)="onImageError()"
        [src]="src"
        [ngClass]="{
            hidden: !loaded(),
            'rounded-full': style() === 'Circle',
            'rounded-[8px]': style() === 'Square'
        }"
        class="w-full aspect-square bg-background object-cover outline outline-1 outline-border-inverted -outline-offset-1"
        alt=""
        />
        } @if (src()) {
        <img
        (load)="onImageLoaded()"
        (error)="onImageError()"
        [src]="src()"
        [ngClass]="{
            hidden: !loaded(),
            'rounded-full': style() === 'Circle',
            'rounded-[8px]': style() === 'Square'
        }"
        class="w-full aspect-square bg-background object-cover outline outline-1 outline-border-inverted -outline-offset-1"
        alt="avatar"
        />
        }
    </div>
    </section>
</ng-template>